module.exports = __webpack_public_path__ + "static/media/signup.4102394e.svg";